import {connect} from 'react-redux';
import Events from './Events.jsx';
import {
  handleNewVirtualEventClick,
  handleNewBowlEventClick,
  handleLinkedEventsToggleClick,
  handleAgeVerificationDateChanged
} from './actions';

const mapStateToProps = state => ({
  eventsAreLinked: state.tournament.base.tournamentInfo.linkEvents,
  canLinkEvents: state.tournament.base.tournamentInfo.canLinkEvents,
  bowlEventsQty: state.tournament.events.bowlEvents.length,
  virtualEventsQty: state.tournament.events.virtualEvents.length,
  ageVerificationDate: state.tournament.base.tournamentInfo.ageVerificationDate,
  readOnly: state.tournament.base.tournamentInfo.readOnly,
  canCreateEvent: state.tournament.base.tournamentInfo.canCreateEvent,
  canCreateVirtualEvent: state.tournament.base.tournamentInfo.canCreateVirtualEvent,
});

const mapDispatchToProps = dispatch => ({
  onNewBowlEventClick: () => dispatch(handleNewBowlEventClick()),
  onNewVirtualEventClick: () => dispatch(handleNewVirtualEventClick()),
  onLinkedEventsToggleClick: () => dispatch(handleLinkedEventsToggleClick()),
  onAgeVerificationDateChange: data => dispatch(handleAgeVerificationDateChanged(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Events);



// WEBPACK FOOTER //
// ./src/features/tournament/events/EventsContainer.jsx